import { MetricDomain } from '@mode/shared/contract-common';
import { ActionReducerMap, createReducer, on } from '@ngrx/store';
import * as DimensionActions from './dimension.actions';

export const dimensionFeatureKey = 'dimension';

export interface State {
  dimensions: ReadonlyArray<MetricDomain.Dimension>;
  isDimensionsLoading: boolean;
  isDimensionsComplete: boolean;
  dimensionsError: Error | null;
}

export const initialState: State = {
  dimensions: [],
  isDimensionsLoading: false,
  isDimensionsComplete: false,
  dimensionsError: null,
};

export const dimensionsReducer = createReducer(
  initialState.dimensions,
  on(DimensionActions.metricRouteLoadDimensions, (state) => state),
  on(DimensionActions.metricRouteLoadDimensionsSuccess, (state, action) => action.dimensions),
  on(DimensionActions.metricRouteLoadDimensionsFailure, (state, action) => [])
);

export const isDimensionsLoadingReducer = createReducer(
  initialState.isDimensionsLoading,
  on(DimensionActions.metricRouteLoadDimensions, (state) => true),
  on(DimensionActions.metricRouteLoadDimensionsSuccess, (state, action) => false),
  on(DimensionActions.metricRouteLoadDimensionsFailure, (state, action) => false)
);

export const isDimensionsCompleteReducer = createReducer(
  initialState.isDimensionsComplete,
  on(DimensionActions.metricRouteLoadDimensions, (state) => false),
  on(DimensionActions.metricRouteLoadDimensionsSuccess, (state, action) => true),
  on(DimensionActions.metricRouteLoadDimensionsFailure, (state, action) => true)
);

export const dimensionsErrorReducer = createReducer(
  initialState.dimensionsError,
  on(DimensionActions.metricRouteLoadDimensions, (state) => null),
  on(DimensionActions.metricRouteLoadDimensionsFailure, (state, action) => action.error)
);

export const reducer: ActionReducerMap<State> = {
  dimensions: dimensionsReducer,
  isDimensionsLoading: isDimensionsLoadingReducer,
  isDimensionsComplete: isDimensionsCompleteReducer,
  dimensionsError: dimensionsErrorReducer,
};
